// extracted by css-extract-rspack-plugin
export default {"container":"_f01664d4","header":"_c4eda60c","circlesContainer":"_c0b66e15","circleLink":"_c98b7181","circleImgWrapper":"_4e5fb6d1","circleImg":"_93f60102","circleName":"_5224fd66"};